const API_URL = process.env.REACT_APP_API_URL;

class BillingService {
  async getAddresses() {
    const response = await fetch(`${API_URL}/billing`, {
      credentials: 'include'
    });
    if (!response.ok) throw new Error('Failed to fetch billing addresses');
    return response.json();
  }

  async addAddress(addressData) {
    const response = await fetch(`${API_URL}/billing`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(addressData)
    });
    if (!response.ok) throw new Error('Failed to add billing address');
    return response.json();
  }

  async updateAddress(id, addressData) {
    const response = await fetch(`${API_URL}/billing/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(addressData)
    });
    if (!response.ok) throw new Error('Failed to update billing address');
    return response.json();
  }

  async deleteAddress(id) {
    const response = await fetch(`${API_URL}/billing/${id}`, {
      method: 'DELETE',
      credentials: 'include'
    });
    if (!response.ok) throw new Error('Failed to delete billing address');
  }
}

const billingService = new BillingService();
export default billingService;
